export const Constants = {
    MediaType: {
        Excel: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
    }
}